import $ from 'jquery';

class ProductVariantSelector {
    constructor(containerSelector, options = {}) {
        // --- 1. Khởi tạo thuộc tính ---
        this.container = $(containerSelector);
        if (!this.container.length) return; // Không làm gì nếu không tìm thấy container

        // Cấu hình options - ưu tiên data attribute trước, sau đó mới đến options parameter
        const dataInitDefault = this.container.data('init-default');
        this.autoInitializeDefaultOptions = dataInitDefault !== undefined ?
            dataInitDefault == 1 :
            (options.autoInitializeDefaultOptions !== false); // Mặc định là true

        // Lấy các element cần tương tác
        this.priceElement = this.container.find('.product-price');
        this.skuElement = this.container.find('.product-sku');
        this.optionLists = this.container.find('.product-options-list');
        this.addToCartBtn = this.container.find('.add-to-cart-btn');

        // Lấy và parse dữ liệu variants từ thẻ script trong container
        this.variantsData = JSON.parse(this.container.find('.product-variants-data').text());

        // "State" của chúng ta: lưu các lựa chọn hiện tại của người dùng
        this.selectedOptions = {};
    }

    // --- 2. Phương thức khởi chạy ---
    init() {
        if (!this.container.length) return;
        this.bindEvents();
        if (this.autoInitializeDefaultOptions) {
            this.initializeDefaultOptions();
        }
    }

    // --- 3. Gán các sự kiện ---
    bindEvents() {
        this.optionLists.on('click', '.option-item', (e) => {
            this.handleOptionClick(e);
        });
    }

    // --- 4. Logic xử lý chính ---
    handleOptionClick(e) {
        const clickedOption = $(e.currentTarget);

        // Kiểm tra xem option có bị disable không
        if (clickedOption.hasClass('option-item-disabled') || clickedOption.prop('disabled')) {
            return; // Không làm gì nếu option bị disable
        }

        const optionGroup = clickedOption.closest('.product-option');
        const optionId = optionGroup.data('option-id');
        const optionValueId = clickedOption.data('option-value-id');

        // Kiểm tra xem option này đã được chọn chưa
        const isAlreadySelected = clickedOption.hasClass('option-item-active');

        if (isAlreadySelected) {
            // Nếu đã chọn rồi thì bỏ chọn
            clickedOption.removeClass('option-item-active');
            delete this.selectedOptions[optionId];
        } else {
            // Nếu chưa chọn thì chọn
            optionGroup.find('.option-item').removeClass('option-item-active');
            clickedOption.addClass('option-item-active');
            this.selectedOptions[optionId] = optionValueId;
        }

        // Tìm variant tương ứng và cập nhật UI
        this.findAndRenderVariant();
    }

    findAndRenderVariant() {
        // Tìm variant trong data khớp với tất cả các lựa chọn trong "state"
        const matchingVariant = this.variantsData.find(variant => {
            // Kiểm tra 2 điều kiện:
            // 1. Tất cả optionvalues của variant phải khớp với selectedOptions
            // 2. selectedOptions phải có đủ tất cả options của variant

            // Điều kiện 1: Tất cả optionvalues của variant khớp với selectedOptions
            const allVariantOptionsMatch = variant.optionvalues.every(optionValue => {
                const optionId = optionValue.option_id;
                const optionValueId = optionValue.option_value_id;
                const selectedValue = this.selectedOptions[optionId];
                return selectedValue == optionValueId;
            });

            // Điều kiện 2: selectedOptions phải có đủ tất cả options của variant
            const selectedOptionsHasAllRequired = variant.optionvalues.every(optionValue => {
                const optionId = optionValue.option_id;
                return this.selectedOptions.hasOwnProperty(optionId);
            });

            return allVariantOptionsMatch && selectedOptionsHasAllRequired;
        });

        // Cập nhật trạng thái disable cho các option items
        this.updateOptionAvailability();

        this.updateUI(matchingVariant);
    }

    // Thêm method mới để cập nhật trạng thái disable của các option
    updateOptionAvailability() {
        this.container.find('.product-option').each((index, el) => {
            const optionGroup = $(el);
            const currentOptionId = optionGroup.data('option-id');

            optionGroup.find('.option-item').each((itemIndex, itemEl) => {
                const optionItem = $(itemEl);
                const optionValueId = optionItem.data('option-value-id');

                // Xoá lựa chọn cũ của group hiện tại trước khi test
                const testSelectedOptions = { ...this.selectedOptions };
                delete testSelectedOptions[currentOptionId];
                testSelectedOptions[currentOptionId] = optionValueId;

                // Kiểm tra xem có variant nào khớp với tổ hợp này không
                const matchingVariants = this.variantsData.filter(variant => {
                    return variant.optionvalues.every(optionValue => {
                        const optionId = optionValue.option_id;
                        const optionValueId = optionValue.option_value_id;
                        const selectedValue = testSelectedOptions[optionId];
                        return (
                            selectedValue === undefined ||
                            selectedValue == optionValueId
                        );
                    });
                });

                // Option được enable nếu có ít nhất 1 variant khớp
                const hasValidVariant = matchingVariants.length > 0;

                if (hasValidVariant) {
                    optionItem.removeClass('option-item-disabled').prop('disabled', false);
                } else {
                    optionItem.addClass('option-item-disabled').prop('disabled', true);
                }
            });
        });
    }


    // --- 5. Cập nhật giao diện (The "View") ---
    updateUI(variant) {
        if (variant) {
            // Lấy UOM ID từ skuElement
            const uomId = this.skuElement.attr('data-uom-id');

            // Tính toán giá bán chính xác sử dụng VariantHelper
            const sellPrice = window.VariantHelper.calculateSellPriceForUom(variant, uomId);

            // Cập nhật giá, SKU
            this.priceElement.text(new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(sellPrice));
            this.skuElement.text(`${variant.sku || variant.id}`).attr('data-id', variant.id);

            // Cập nhật slider ảnh (bạn có thể gọi một method của module gallery tại đây)
            // gallerySlider.goToImage(variant.image);

            // Cập nhật nút Add to Cart
            const enabledText = this.addToCartBtn.data('text-enabled') || 'Add to Cart';
            this.addToCartBtn.prop('disabled', false).removeClass('disabled').text(enabledText);
            // if (variant.available) {
            //     this.addToCartBtn.prop('disabled', false).text('Thêm vào giỏ hàng');
            // } else {
            //     this.addToCartBtn.prop('disabled', true).text('Hết hàng');
            // }
        } else {
            // Xảy ra khi một tổ hợp không tồn tại (ví dụ: Màu Đỏ không có size S)
            // Hoặc khi người dùng chưa chọn đủ option
            // Sử dụng giá mặc định từ data-sellprice để tránh re-layout
            const defaultPrice = this.priceElement.data('sellprice');
            if (defaultPrice) {
                this.priceElement.text(new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(defaultPrice));
            } else {
                this.priceElement.text(''); // Fallback nếu không có data-sellprice
            }
            this.skuElement.text('').removeAttr('data-id'); // Clear SKU và remove data-id
            const disabledText = this.addToCartBtn.data('text-disabled') || 'Please select a variant';
            this.addToCartBtn.prop('disabled', true).addClass('disabled').text(disabledText);
        }
    }

    // Khởi tạo các lựa chọn mặc định nếu cần
    initializeDefaultOptions() {
        // Tìm tất cả các option groups (product-option)
        this.container.find('.product-option').each((index, el) => {
            const optionGroup = $(el);
            const firstOption = optionGroup.find('.option-item').first();

            if (firstOption.length) {
                // Lấy thông tin option
                const optionId = optionGroup.data('option-id');
                const optionValueId = firstOption.data('option-value-id');

                if (optionId && optionValueId) {
                    // Cập nhật giao diện
                    optionGroup.find('.option-item').removeClass('option-item-active');
                    firstOption.addClass('option-item-active');

                    // Cập nhật state
                    this.selectedOptions[optionId] = optionValueId;
                } else {
                    console.warn('Missing option-id or option-value-id data attributes');
                }
            }
        });

        // Cập nhật trạng thái disable cho các option items
        this.updateOptionAvailability();

        // Sau khi khởi tạo tất cả options, tìm và render variant
        this.findAndRenderVariant();
    }
}

export default ProductVariantSelector;